import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ngx-language-select',
    template: `  
        <nb-select [selected]="currentLanguage" (selectedChange)="changeLanguage($event)" status="primary">
            <nb-option *ngFor="let lang of translate.getLangs()" [value]="lang" > {{ lang }}</nb-option>
        </nb-select>
        `,
    standalone: false
})

export class LanguageSelectComponent {
    public currentLanguage;
    
    constructor(public translate: TranslateService)
    { 
        this.currentLanguage = translate.currentLang;
    }

    public changeLanguage(language: string)
    {
       this.translate.use(language);
    }
}